import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const notesApi = {
  list: (params = {}) => api.get("/notes", { params }).then((r) => r.data),
  create: (payload) => api.post("/notes", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/notes/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/notes/${id}`).then((r) => r.data),
  emptyTrash: () => api.post("/notes/empty-trash").then((r) => r.data),
};

export const labelsApi = {
  list: () => api.get("/labels").then((r) => r.data),
  create: (name) => api.post("/labels", { name }).then((r) => r.data),
  update: (id, name) => api.put(`/labels/${id}`, { name }).then((r) => r.data),
  remove: (id) => api.delete(`/labels/${id}`).then((r) => r.data),
};

// Public URL for an uploaded image path
export const fileUrl = (path) => `${API}/files/${path}`;

export async function uploadImage(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { path, size, content_type }
}

export async function uploadDocument(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload-doc", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { path, size, content_type, filename }
}
